import React from "react";
import { connect } from "react-redux";
import * as actions from "Actions";
import RentalSection from "./RentalSection";
import InventoryDiscountsFeesTable from "./InventoryDiscountsFeesTable";
import { DISCOUNT_DISPLAY_DEFAULT } from "Constants/discountDisplay";
import { shouldHidePrice } from "HelperFunctions/HidePricing";

class RentalItemList extends React.Component {
  render() {
    const { rental, storefrontShopSetting } = this.props;

    const { approvalStatus, rentalSections, rentalSetting } = rental;
    const {
      showItemImages,
      showItemNotes,
      showUnitPricingToCustomers,
      showSubtotalsInSections,
      discountDisplay,
      displayAggregatedInventoryPrices,
    } = rentalSetting;
    const tileView = showItemImages;
    const hideSubtotalPricing = shouldHidePrice(
      approvalStatus,
      storefrontShopSetting
    );
    return (
      <section className='items'>
        {rentalSections
          .filter(
            (section) =>
              !section.sectionMemberships.every(
                (sm) => sm.rentalInventoryType === "RentalAccessory"
              )
          )
          .map(
            (section) =>
              section.sectionMemberships.length > 0 && (
                <RentalSection
                  key={section.id}
                  rental={rental}
                  section={section}
                  tileView={tileView}
                  approvalStatus={approvalStatus}
                  discountDisplay={discountDisplay || DISCOUNT_DISPLAY_DEFAULT}
                  showItemImages={showItemImages}
                  showItemNotes={showItemNotes}
                  showUnitPricingToCustomers={showUnitPricingToCustomers}
                  showSubtotalsInSections={showSubtotalsInSections}
                />
              )
          )}
        {/* Rendered inside section.items (as a sibling div to the section
            divs) so it inherits the same themed CSS as the item tables. */}
        {!hideSubtotalPricing && (
          <InventoryDiscountsFeesTable
            billingLines={rental.billingLines}
            discountDisplay={discountDisplay || DISCOUNT_DISPLAY_DEFAULT}
            displayAggregatedInventoryPrices={displayAggregatedInventoryPrices}
          />
        )}
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  const { parsedStorefrontSettings } = state.locations;
  const storefrontShopSetting = parsedStorefrontSettings.storefrontShopSetting;

  return { storefrontShopSetting };
};

export default connect(mapStateToProps, actions)(RentalItemList);
